import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';

export const authRoleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const expectedRole = route.data['expectedRole'];

  const user = authService.currentUserValue;

  if (user && user.roles.some(role => role.name === expectedRole)) {
    return true;
  } else {
    router.navigate(['/authentication/page403'], { queryParams: { origem: state.url } });
    return false;
  }
};
